import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { TabPanel, TabView } from "primereact/tabview";
import Loader from "../../components/Loadeer/Loader";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { getSpecificDetails } from "../../service/ProductService";
import { GET_FARMER_PROFILE } from "../../config/ApiConstant";
import { Toast } from "primereact/toast";
import FarmList from "./FarmList";
import FarmerBookingList from "./FarmerBookingList";
import { Avatar } from "primereact/avatar";

const FarmerDetail = () => {
  document.title = "Farmer Detail | Agriown";

  // Set Toast
  const toast = useRef<Toast>(null);
  // get farmer id from url
  const { id }: any = useParams();
  // decode farmer id
  const farmer_id = atob(id);
  // state to store farmer details
  const [farmerDetail, setFarmerDetail] = useState<any>({});
  // state to store active tab index
  const [activeIndex, setActiveIndex] = useState<number>(0);
  // loading state
  const [pageLoader, setPageLoader] = useState<boolean>(false);

  // useeffect for fetching farmer profile data on page load
  useEffect(() => {
    getProfileData();
  }, [farmer_id]);

  // fetch farmer profile data using farmer_id
  const getProfileData = async () => {
    try {
      setPageLoader(true);
      const response = await getSpecificDetails(GET_FARMER_PROFILE, farmer_id);

      if (response) {
        setFarmerDetail(response);
        setPageLoader(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
      });
      setPageLoader(false);
    }
  };

  return (
    <>
      {/* Breadcrumb */}
      <AppBreadcrumb
        currentMenu={"Farmer"}
        pageName={"Farmer Profile"}
        pageTitle={"Farmer Profile"}
        goToPage={true}
      />
      <Toast ref={toast} />
      {!window.cn(farmerDetail) && (
        <div className="grid mt-3 profile-page">
          <div className="pb-0 col-12">
            <div className="card profile-card">
              <div className="card-profile-detail">
                <div>
                  {!window.cn(farmerDetail?.profile_img) ? (
                    <div className="img-fluid">
                      <img
                        src={farmerDetail?.profile_img}
                        className="img-fluid"
                        width={100}
                        height={100}
                      />
                    </div>
                  ) : (
                    <div className="img-fluid">
                      <Avatar
                        label={farmerDetail?.name?.charAt(0).toUpperCase()}
                        style={{
                          backgroundColor: "#438440",
                          color: "#ffffff",
                          width: "7rem",
                          height: "7rem",
                          fontSize: "3rem",
                          borderRadius: "0",
                        }}
                      />
                    </div>
                  )}
                </div>
                <div className="pt-0 md:ml-4 p-other-info">
                  {!window.cn(farmerDetail?.name) && (
                    <div>
                      <h6 className="mb-0 full-n-p">{farmerDetail?.name}</h6>
                    </div>
                  )}
                  <div className="flex personal-info">
                    {!window.cn(farmerDetail?.email) && (
                      <div className="flex mr-5 align-items-center">
                        <i className="mr-2 pi pi-envelope"></i>
                        <h6 className="mt-0 mb-0 desg">
                          {farmerDetail?.email}
                        </h6>
                      </div>
                    )}
                    {!window.cn(farmerDetail?.mobile) && (
                      <div className="flex mr-5 align-items-center">
                        <i className="mr-2 pi pi-phone"></i>
                        <h6 className="mt-0 mb-0 desg">
                          {farmerDetail?.mobile}
                        </h6>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* TabView for Farmer Profile */}
      <TabView
        activeIndex={activeIndex}
        onTabChange={(e) => setActiveIndex(e.index)}
        className="profile-tab"
      >
        <TabPanel header="Farm List">
          <FarmList />
        </TabPanel>
        <TabPanel header="Booking List">
          <FarmerBookingList />
        </TabPanel>
      </TabView>

      {pageLoader === true && <Loader />}
    </>
  );
};

export default FarmerDetail;
